import http from "../../httpService";
import { apiUrl } from "../../../../config.js";

const apiEndpoint = apiUrl + "/setup/finance/";

export function getGlAccounts(accountTypeID) {
  return http.get(apiEndpoint + "glaccounts/" + accountTypeID);
}

export function getGlAccount(glAccountID = 0, predID = 0) {
  return http.get(apiEndpoint + "glaccount/" + glAccountID + "/" + predID);
}

export function saveGlAccount(glAccount) {
  return httpSaveData("glaccount", glAccount);
}

export function deleteGlAccount(glAccountID) {
  return http.delete(apiEndpoint + "glaccount/" + glAccountID);
}

export function getFinanceMasterDataAPI() {
  return http.get(apiEndpoint + "finance-master-data");
}

export function getBankAccounts() {
  return http.get(apiEndpoint + "bankaccounts");
}

export function saveBankAccount(bankAccount) {
  return httpSaveData("bankaccount", bankAccount);
}

export function deleteBankAccount(bankAccountID) {
  return http.delete(apiEndpoint + "bankaccount/" + bankAccountID);
}

export function getTaxes() {
  return http.get(apiEndpoint + "taxes");
}

export function saveTax(tax) {
  return httpSaveData("tax", tax);
}

export function deleteTax(taxID) {
  return http.delete(apiEndpoint + "tax/" + taxID);
}

export function getCurrencies() {
  return http.get(apiEndpoint + "currencies");
}

export function saveCurrency(currency) {
  return httpSaveData("currency", currency);
}

export function deleteCurrency(currencyID) {
  return http.delete(apiEndpoint + "currency/" + currencyID);
}

function httpSaveData(path, data) {
  if (data.ID === 0) {
    return http.post(apiEndpoint + path, data);
  } else {
    return http.put(apiEndpoint + path, data);
  }
}

export function getFiscalYearPeriods(year) {
  return http.get(apiEndpoint + "fiscal-year-periods/" + year);
}

export function getFiscalYears() {
  return http.get(apiEndpoint + "fiscal-years");
}

export function getCurrentFiscalYear() {
  return http.get(apiEndpoint + "current-fiscal-year");
}

export function getFiscalPeriods() {
  return http.get(apiEndpoint + "fiscal-periods");
}

export function getCurrentFiscalPeriod() {
  return http.get(apiEndpoint + "current-fiscal-period");
}

export function deleteFiscalPeriod(fiscalPeriodID = 0) {
  return http.delete(apiEndpoint + `fiscal-period/${fiscalPeriodID}`);
}

export function saveFiscalPeriod(period) {
  return http.post(apiEndpoint + "fiscal-period", period);
}
